import { useRouteError } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  return (
    <div id="error-page">
      <h1>Oops! תקלה</h1>
      <p>כרעם ביום בהיר, קרתה תקלה</p>
      <p>
        <i>{error.statusText || error.message}</i>
      </p>
    </div>
  );
}